module.exports = __webpack_public_path__ + "media/images/default_banner_2-0f74127f0e33dd2c7604c85aa482e639.webp";